import { Select } from 'antd';
import LabelledRow from '../LabelledRow';
import { SHADOW_LABEL, SHADOW_OPTIONS } from '../../../shared/boxes/shadowStyles';
import { ACCORDION_PANEL_GROUP, ACCORDION_PANEL_LABELS } from '../../../shared/boxes/accordionPanel/accordionPanelLabels';
import BoxColorField from './BoxColorField';
import BoxBorderFields from './BoxBorderFields';
import FieldGroupLabel from './FieldGroupLabel';

/**
 * Réglages d'un Volet — servis à l'identique dans le configurateur du template
 * (où ils décrivent un modèle) et dans le panel de droite d'une box (où ils
 * personnalisent cette box).
 *
 * Même ligne que les autres panneaux de box : libellé à gauche, contrôle à
 * droite (cf. InfoCardFields).
 */
const AccordionPanelFields = ({
  style = {}, locked, setProp, labelOfColor, colorOfLabel,
}) => (
  <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
    <FieldGroupLabel>{ACCORDION_PANEL_GROUP}</FieldGroupLabel>
    <LabelledRow label={ACCORDION_PANEL_LABELS.panelColor}>
      <BoxColorField
        label="Couleur du volet"
        disabled={locked}
        value={labelOfColor(style.panelColor)}
        onChange={(label) => setProp('panelColor', colorOfLabel(label))}
      />
    </LabelledRow>
    <LabelledRow label={ACCORDION_PANEL_LABELS.answerBackground}>
      <BoxColorField
        label="Couleur de fond de la réponse"
        disabled={locked}
        value={labelOfColor(style.answerBackground)}
        onChange={(label) => setProp('answerBackground', colorOfLabel(label))}
      />
    </LabelledRow>
    {/* Couleurs de DÉPART des deux textes, propres au document : sur le
        site, le HTML produit porte déjà ses couleurs. La barre de mise en
        forme permet d'en déroger mot à mot. */}
    <LabelledRow label="Couleur de la question">
      <BoxColorField
        label="Couleur de la question"
        disabled={locked}
        value={labelOfColor(style.questionColor)}
        onChange={(label) => setProp('questionColor', colorOfLabel(label))}
      />
    </LabelledRow>
    <LabelledRow label="Couleur de la réponse">
      <BoxColorField
        label="Couleur de la réponse"
        disabled={locked}
        value={labelOfColor(style.answerColor)}
        onChange={(label) => setProp('answerColor', colorOfLabel(label))}
      />
    </LabelledRow>
    <LabelledRow label={SHADOW_LABEL}>
      <Select
        size="small"
        disabled={locked}
        value={style.shadow ?? 'none'}
        options={SHADOW_OPTIONS}
        onChange={(value) => setProp('shadow', value)}
        style={{ width: 116 }}
      />
    </LabelledRow>
    <BoxBorderFields
      border={style.border}
      locked={locked}
      labelOfColor={labelOfColor}
      colorOfLabel={colorOfLabel}
      onChange={(border) => setProp('border', border)}
    />
  </div>
);

export default AccordionPanelFields;
